import { apiClient } from "../../lib/api-client";
import type { BookCardData } from "../../components/BookCard";

export interface CatalogListResponse {
  items: BookCardData[];
  nextCursor: string | null;
}

export function fetchCatalog(params: { q?: string; categoria?: string; autor?: string }): Promise<CatalogListResponse> {
  const search = new URLSearchParams();
  if (params.q) search.set("q", params.q);
  if (params.categoria) search.set("categoria", params.categoria);
  if (params.autor) search.set("autor", params.autor);
  const query = search.toString();
  return apiClient.get<CatalogListResponse>(`/public/catalog${query ? `?${query}` : ""}`);
}

export interface BookDetail extends BookCardData {
  id: string;
  description: string | null;
  isbn: string | null;
  publisher: string;
  formats: ("pdf" | "epub")[];
  authors: { id: string; name: string; slug: string }[];
  hasPreview: boolean;
}

export function fetchBookDetail(slug: string): Promise<BookDetail> {
  return apiClient.get<BookDetail>(`/public/catalog/${slug}`);
}
